import React from 'react'
import { useTranslation } from 'react-i18next'
import { Avatar, Box, Highlight, RowsSkeletonLoader } from '@node-space/ui-components'
import { WalletCustodyModel, type CustomerWallet } from 'types/customers'
import { roundNumberWithCommas } from 'utils/utils'

interface CustomerWalletPageHeaderProps {
  customerWallet: CustomerWallet
  isLoading: boolean
}

const CustomerWalletPageHeader = ({ customerWallet, isLoading }: CustomerWalletPageHeaderProps) => {
  const { t } = useTranslation()
  const isSelfCustodial = customerWallet?.custodyModel === WalletCustodyModel.SELF_CUSTODIAL

  return isLoading ? (
    <Box width="full" flex>
      <Box className="w-40 h-8">
        <RowsSkeletonLoader rows={1} />
      </Box>
    </Box>
  ) : (
    <Box width="full" flex className="py-3">
      <Avatar size="small" name={customerWallet?.balance?.currencyCode} />

      <Box flexSize="fill" paddingL={16} gapY={4} flex className="items-center">
        <h1 className="text-h1 text-foreground-prominent leading-6">
          {`${roundNumberWithCommas(Number(customerWallet?.balance?.value) || 0, 2)} ${customerWallet?.balance?.currencyCode}`}
        </h1>

        {isSelfCustodial && (
          <Box paddingL={8}>
            <Highlight type="neutral" variant="emphasis">
              {t('customers.custodyModelSelfHosted')}
            </Highlight>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default CustomerWalletPageHeader
